import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import Address from 'components/location/address';
import Price from 'components/bookings/price';
import Toggle from 'components/bookings/past/info/toggle';
import Status from 'components/bookings/past/info/status';
import Action from 'components/bookings/past/info/action';
import ThinNextArrow from 'components/svgs/icons/thin-next-arrow';

import Brand from 'models/brand';
import BookingModel from 'models/booking';
import { Location } from 'models/locations';

const propTypes = {
  brand: PropTypes.instanceOf(Brand).isRequired,
  booking: PropTypes.instanceOf(BookingModel).isRequired,
  location: PropTypes.instanceOf(Location).isRequired,
  disabled: PropTypes.bool,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
};

const defaultProps = {
  disabled: false,
  selected: false,
  onClick: null,
};

const Info = ({ location, booking, selected, disabled, onClick, brand }) => {
  const monthly = booking.type === 'monthly_booking';
  const tableClasses = cx({
    'highlighted': selected,
    'bp-highlighted': selected && brand.isBestParking,
    'dark-background': selected,
    'disabled': disabled,
    'shadowed-xs': true,
    'row': true,
    'mock-table-row': true,
    'clickable-row': true,
    'clickable': !booking.onDemand,
  });
  let startTime;
  let endTime;

  if (monthly) {
    startTime = <div className="col-xs-4 padding-right-0 middle-icon">{booking.startTime.format('ddd MMM DD').toUpperCase()}</div>;
    endTime = <div className="col-xs-4 middle-icon">MONTHLY</div>;
  } else {
    startTime = (<div className="col-xs-4">
      <div>{booking.startTime.format('h:mm A')}</div>
      <div className="grid-header weak">{booking.startTime.format('ddd MMM DD').toUpperCase()}</div>
    </div>);
    endTime = (<div className="col-xs-4">
      <div>{booking.endTime.format('h:mm A')}</div>
      <div className="grid-header weak">{booking.endTime.format('ddd MMM DD').toUpperCase()}</div>
    </div>);
  }

  return (
    <div className={tableClasses} onClick={onClick}>
      <div className="col-lg-3 col-sm-4">
        <div className="row">
          <div className="col-xs-2 col-gutter-left-8 col-gutter-right-8">
            <Toggle disabled={disabled} selected={selected} onDemand={booking.onDemand} />
          </div>
          <div className="col-md-10 booking-address">
            <Address location={location} />
          </div>
        </div>
      </div>
      <div className="col-lg-5 col-sm-6">
        <div className="row">
          {startTime}
          <div className="col-xs-1 padding-0">
            <div className="middle-icon">
              {monthly ? null : <ThinNextArrow />}
            </div>
          </div>
          {endTime}
          <div className="col-xs-3 padding-0">
            <Price
              booking={booking}
              location={location}
              type="paid"
            />
          </div>
        </div>
      </div>
      <div className="col-lg-2 hidden-lte-md">
        <Status
          booking={booking}
          disabled={disabled}
        />
      </div>
      <div className="col-xs-2">
        <Action
          selected={selected}
          booking={booking}
          location={location}
          brand={brand}
        />
      </div>
    </div>
  );
};

Info.propTypes = propTypes;
Info.defaultProps = defaultProps;
export default Info;
